import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';

const useMusicStore = create(
	persist(
		devtools((set, get) => ({
			// режим и выбранный трек
			isRandom: true,
			selectedKey: null,
			selectedSrc: null,

			setRandom(enabled) {
				set({ isRandom: !!enabled });
				if (enabled) {
					set({ selectedKey: null, selectedSrc: null });
				}
			},

			// Установить режим рандома и подготовить выбранный src (без автоплея)
			setRandomSource(src) {
				set({ isRandom: true, selectedKey: null, selectedSrc: src || null });
			},

			selectTrack(track) {
				if (!track) return;
				set({
					isRandom: false,
					selectedKey: track.key || null,
					selectedSrc: track.src || null,
				});
			},

			clearSelection() {
				set({ selectedKey: null, selectedSrc: null });
			},
		})),
		{ name: 'MusicStore' }
	)
);

export default useMusicStore;


